import React from "react";
import { Formik } from "formik";
import { Form, Col, Row } from "react-bootstrap";

export function CourseSubjectEditForm({ 
  courseSubject,
  btnRef,
  saveCourseSubject
}) {
  return (
    <Formik 
      enableReinitialize={true}
      initialValues={courseSubject}
      onSubmit={(values) => saveCourseSubject(values)}
    >
      {({ handleSubmit, handleChange, values }) => (
        <Form onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
        }}>
          <Form.Group as={Row} controlId="subject">
            <Form.Label column sm={2}>
              Konu<span> *</span>
            </Form.Label>
            <Col sm={10}>
              <Form.Control type="text" value={values.subject} placeholder="Konu" onChange={handleChange} />
            </Col>
          </Form.Group>
          
          <Form.Group as={Row} controlId="code">
            <Form.Label column sm={2}>
              Kodu<span> *</span>
            </Form.Label>
            <Col sm={10}>
              <Form.Control type="text" value={values.code} placeholder="Kodu" onChange={handleChange} />
            </Col>
          </Form.Group>
          
          <Form.Group as={Row} controlId="explanation">
            <Form.Label column sm={2}>
              Açıklaması
            </Form.Label>
            <Col sm={10}>
              <Form.Control type="text" value={values.explanation} placeholder="Açıklaması" onChange={handleChange} />
            </Col>
          </Form.Group>
          
          <button
            type="submit"
            style={{ display: "none" }}
            ref={btnRef}
          ></button>
        </Form>
      )}      
    </Formik>
  );
}